<template>
<article class="results-list__item results-list__item--bills" data-id="results-list-item">
  <div class="bill-details" :class="this.actionClass">
    <div class="bill-details__position" :class="this.positionClass">
      <div class="bill-details__position-text u-primary-title" :class="this.positionTypeClass">{{ item.position_friendly }}</div>
    </div>
    <div class="bill-details__content">
      <h3 class="bill-details__title u-medium-title u-sans-serif u-sans-serif-title u-type-28 u-type-until-bp-small-24">
        <a :href="href" class="u-primary-very-dark u-hover-tertiary-dark" target="_blank">
          {{ item.title }}
          <span class="bill-details__title-suffix">
                <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg"><path d="m7.94 0 2.605 2.624L5 8.169l1.117 1.117 5.545-5.546 2.624 2.606V0H7.94zm5.4 12.705H1.66V1.58H7.5L5.84 0H1.66A1.64 1.64 0 0 0 .488.465C.163.775 0 1.147 0 1.581v11.124c0 .434.163.806.488 1.116.326.31.716.465 1.172.465h11.68a1.64 1.64 0 0 0 1.172-.465c.325-.31.488-.682.488-1.116V8.724l-1.66-1.581v5.562z" fill="currentColor" fill-rule="evenodd"/></svg>
                {{ item.host ? item.host : 'congress.gov' }}
              </span>
        </a>
      </h3>
      <div class="bill-details__issue-date">
        <ul class="bill-details__issues" v-if=" item.issue_explainer_title">
          <template v-if="Array.isArray(item.issue_explainer_title)">
            <li class="bill-details__issue" v-for="(n, index) in 2">
              <a :href="item.issue_explainer_path[index]">{{ item.issue_explainer_title[index] }}</a>
            </li>
          </template>
          <template v-else>
            <li class="bill-details__issue">
              <a :href="item.issue_explainer_path">{{ item.issue_explainer_title }}</a>
            </li>
          </template>
        </ul>
        <p class="bill-details__date u-sans-serif u-type-12 u-before-bg-primary-medium-dark" v-if="item.publish_date">Introduced on {{ item.publish_date | date }}</p>
      </div><!--/.bill-details__issue-date-->
      <p class="bill-details__description u-sans-serif u-type-16">{{ item.summary | strip }}</p>

      <div class="bill-details__related-letter" v-if="item.most_recent_letter_title">
        <p class="bill-details__related-letter-label">Most Recent Letter:</p>
        <p class='bill-details__related-letter-link u-type-16'><a :href="item.most_recent_letter_path">{{ item.most_recent_letter_title }}</a></p>
      </div>

    </div><!--/.bill-details__content-->
    <div class="bill-details__action" v-if="item.related_action_title">
      <div class="bill-details__action-inside" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions,}" :class="classes">
        <a class="bill-details__action-inside-link u-bg-primary-dark-gradient" :href="item.related_action_path">
          <p class="bill-details__action-tophat u-bg-secondary-dark" v-if="item.related_action_is_donate && item.related_action_is_donate === '1'">Donate</p>
          <p class="bill-details__action-tophat u-bg-secondary-dark" v-else>Take Action</p>
          <h4 class="bill-details__action-title u-medium-title u-sans-serif u-sans-serif-title u-type-20 u-type-until-bp-small-18">{{ item.related_action_title }}</h4>
          <span class="bill-details__action-cta btn btn--secondary btn--small">
                {{ item.related_action_cta }}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
                  <path fill="currentColor" fill-rule="nonzero" d="M75 18L91 22 75 26 77.228 22z" transform="translate(-75 -18)"></path>
                </svg>
              </span>
        </a>
      </div>
    </div>
  </div><!--/.bill-details-->

</article>
</template>

<script>

export default {
  name: 'ResultsListBillItem',
  props: ['item'],
  data() {
    return {
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.80, 0.20] // [0.25, 0.75] if you want a 25% offset!
      },
      classes: '',
    }
  },
  computed: {
    href () {
      if(this.item.link) {
        return this.item.link
      }
      else if(this.item.path) {
        return this.item.path
      }
      else {
        return this.item.url
      }
    },
    title () {
      // PDFs and other indexed files do not have a path
      return this.item.path ? this.item.title : decodeURIComponent(this.item.url.substring(this.item.url.lastIndexOf('/') + 1));
      //return this.item.path ? this.item.title : this.truncateBody(5); // PDFs' flattened content
    },
    summary () {
      return this.item.path ? this.item.summary : this.truncateBody(25);
    },
    positionClass () {
      // @TODO TID constants?
      if(this.item.position_friendly==='Support') {
        return 'bill-details__position--good u-bg-secondary-light';
      }
      if(this.item.position_friendly==='Oppose') {
        return 'bill-details__position--bad u-bg-tertiary-very-dark';
      }
      return 'bill-details__position--neutral u-bg-primary-light';
    },
    positionTypeClass () {
      // @TODO TID constants?
      if(this.item.position_friendly==='Support' || this.item.position_friendly==='Oppose') {
        return 'u-type-28';
      }
      return 'u-type-20';
    },
    actionClass () {
      return this.item.related_action_title ? ' bill-details--action' : ''
    }
  },
  methods: {
    onWaypoint({ going }) {
      // going: in, out
      if (going === this.$waypointMap.GOING_IN) {
        this.classes = 'is-in';
      }
    },
    isTruncatable(length, data) {
      return data.split(' ').length > (length - 1)
    },
    truncateBody(length) {
      // body contains PDFs' flattened content
      if (this.isTruncatable(length, this.item.body)) {
        return `${this.item.body.split(' ').slice(0, (length - 1)).join(' ')}...`
      }
      return this.item.body
    },
  }
}
</script>
